const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      { component: "search-disaster-types", label: "재해형태", value: "disaster", query: { dty: "disaster" }, options: {} },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["부서명", "재해형태", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({ key: "body.stdInfo.재해형태", operator: "LIKE", value: `${search.disaster}` });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "부서명",
        key: "field.com_name",
        sortKey: false,
      },
      {
        name: "팀명",
        key: "field.team_company_list[%].com_name",
        sortKey: false,
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "재해형태",
        key: "body.stdInfo.재해형태",
      },
      {
        name: "담당자",
        key: "body.개선결과.개선내용담당자",
      },
      {
        name: "개선일자",
        key: "body.개선결과.개선내용개선일자",
      },
      {
        name: "개선 전",
        key: "",
      },
      {
        name: "소속명",
        key: "body.stdInfo.department",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const content = func.getContent(value);
      switch (index) {
        case 0: {
          const meta = JSON.parse(value.field.meta || "{}");
          return func.getContent(value).stdInfo.부서명_과 || meta.com_name; // 부서명_과
        }
        case 1: {
          const team_company_list = JSON.parse(value.field.meta || "{}").team_company_list;
          return team_company_list ? team_company_list.map((team) => team.com_name).join(", ") : "-";
        }
        case 2:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 3:
          return func.getContent(value).stdInfo.재해형태; // 재해형태
        case 4:
          const 담당자 = content.개선결과.map((item) => item.개선내용담당자).filter((v) => v && v.trim() !== "");
          return [...new Set(담당자)].join(", "); // 담당자
        case 5:
          const 개선일자 = content.개선결과.map((item) => item.개선내용개선일자).filter((v) => v && v.trim() !== "");
          return [...new Set(개선일자)].join(", "); // 개선일자
        case 6:
          const checkAllObjectsEmpty = (arr) => {
            return arr.every((obj) => {
              const is개선전사진Empty = obj.개선전사진.every((p) => !p.id && !p.path && !p.fileName);
              const is감소대책Empty = !obj.감소대책;
              const is감소빈도Empty = !obj.감소빈도;
              const is감소강도Empty = !obj.감소강도;

              const is개선후사진Empty = obj.개선후사진.every((p) => !p.id && !p.path && !p.fileName);
              const is담당자Empty = !obj.개선내용담당자;
              const is개선일자Empty = !obj.개선내용개선일자;
              // 요청사항: 개선빈도 와 개선강도는 별 표시 조건에서 제외
              const is개선빈도Empty = !obj.개선빈도;
              const is개선강도Empty = !obj.개선강도;

              return !(is개선전사진Empty && is감소대책Empty && is감소빈도Empty && is감소강도Empty)
                && (is개선후사진Empty && is담당자Empty && is개선일자Empty);
            });
          };
          return checkAllObjectsEmpty(content.개선결과) ? "★" : ""; // 개선내용있으면 별
        case 7:
          return func.getContent(value).stdInfo.department; // 소속명
        case 8:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 9:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
